export default (isPerCouponGroupingEnabled, baseUrl, queryObj = {}) => {
  if (isPerCouponGroupingEnabled) {
    return [
      baseUrl,
      {
        groupByCampaigns: true,
        ...queryObj,
      },
    ];
  }
  return [
    baseUrl,
    queryObj,
  ];
};
